// Quantidades do carrinho por produto.
//
// O carrinho (store.state.carrinho) guarda apenas os IDs dos produtos e é
// sincronizado com a conta do cliente (ver App.vue -> /api/cart_save.php).
// Para suportar o seletor de quantidade nos cards sem alterar esse formato,
// as quantidades ficam em um mapa separado { [idProduto]: quantidade },
// salvo em localStorage ("carrinhoQuantidades"). Um produto sem entrada no
// mapa vale 1 unidade, como sempre foi.
const CHAVE = "carrinhoQuantidades";

function ler() {
  try {
    const bruto = localStorage.getItem(CHAVE);
    const mapa = bruto ? JSON.parse(bruto) : {};
    return mapa && typeof mapa === "object" && !Array.isArray(mapa) ? mapa : {};
  } catch (e) {
    return {};
  }
}

function gravar(mapa) {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(mapa));
  } catch (e) {
    /* armazenamento indisponível: segue com quantidade padrão */
  }
}

export default {
  chave: CHAVE,
  get(id) {
    const n = parseInt(ler()[String(id)], 10);
    return n >= 1 ? n : 1;
  },
  set(id, qtd) {
    const n = parseInt(qtd, 10);
    const mapa = ler();
    if (n >= 1) mapa[String(id)] = n;
    else delete mapa[String(id)];
    gravar(mapa);
  },
  remove(id) {
    const mapa = ler();
    delete mapa[String(id)];
    gravar(mapa);
  },
  limpar() {
    try {
      localStorage.removeItem(CHAVE);
    } catch (e) {
      /* ignora */
    }
  },
};
